export default "__VITE_ASSET__C_XMH9Fm__"